module.exports = __webpack_public_path__ + "img/zh_CN.5f937ec.jpg";